<style>
  .mat-cell, .mat-header-cell {
    padding: 10px;
  }

  .nomarginbutton {
    margin: 0 !important;
  }

  .fix-static-bug {
    width: 100% !important;
    position: static !important;
  }

  h3 {
    margin-bottom: 25px;
  }

  h4 {
    margin-bottom: 15px;
    margin-left: 2px;
  }

  .card-margin {
    margin-bottom: 15px;
  }

  .input-card {
    padding: 15px;
  }

  .save-button {
    padding: 10px 24px !important;
    width: 50%;
  }

  .save-button-container {
    display: flex;
    justify-content: flex-end;
  }
</style>

<div class="settings-page">
  <div class="settings-card">
    <div class="settings-content">
      <div class="settings-content-inner">
        <div class="title">
          <h3 class="sam-page-heading">KONTOINSTÄLLNINGAR</h3>
        </div>

        <div *ngIf="loadErrorMessage" role="alert">
          <p>{{ loadErrorMessage }}</p>
          <button mat-stroked-button type="button" (click)="loadUser()" [disabled]="isLoading">Försök igen</button>
        </div>

        <div *ngIf="isChildAccount" class="child-account-disclaimer">
          Kontot administreras av en central administratör
        </div>

        <!-- ********************* -->
        <!-- Private user settings -->
        <!-- ********************* -->

        <div class="settings-form-section" *ngIf="user && (appId == 2 || (appId == 1 && !user.IsCompany))">
          <div class="settings-form-body backgroundcolor">

            <form name="form" (ngSubmit)="f.form.valid && onSubmit()" #f="ngForm" novalidate>
              <mat-card class="card-margin input-card">
                <div class="row" style="margin-bottom: 15px;">
                  <div class="col-12 settings-card-heading">
                    <span class="settings-card-heading-icon" aria-hidden="true"><mat-icon>person_outline</mat-icon></span>
                    <h4>Personuppgifter</h4>
                  </div>

                  <div class="col-sm-6">
                    <mat-form-field appearance="fill" style="width: 100%" floatLabel="always">
                      <mat-label>Förnamn</mat-label>
                      <input [disabled]="user.CreatedFromSpar" matInput required [ngModel]="user?.FirstName" (ngModelChange)="user.FirstName = $event" id="firstname" name="firstname">
                    </mat-form-field>
                  </div>
                  <div class="col-sm-6">
                    <mat-form-field appearance="fill" style="width: 100%" floatLabel="always">
                      <mat-label>Efternamn</mat-label>
                      <input [disabled]="user.CreatedFromSpar" matInput required [ngModel]="user?.LastName" (ngModelChange)="user.LastName = $event" id="lastname" name="lastname">
                    </mat-form-field>
                  </div>



                  <div class="col-sm-12">
                    <mat-form-field appearance="fill" style="width: 100%" floatLabel="always">
                      <mat-label>Namn som visas som avsändare på fakturan</mat-label>
                      <input matInput required [ngModel]="user?.DisplayName" (ngModelChange)="user.DisplayName = $event" id="displayname" name="displayname">
                    </mat-form-field>
                  </div>
                  <div class="col-sm-6">
                    <mat-form-field appearance="fill" style="width: 100%" floatLabel="always">
                      <mat-label>Telefon</mat-label>
                      <input matInput [ngModel]="user?.Phone" required (ngModelChange)="user.Phone = $event" id="telephone" name="telephone">
                    </mat-form-field>
                  </div>
                  <div class="col-sm-6">
                    <mat-form-field appearance="fill" style="width: 100%" floatLabel="always">
                      <mat-label>E-post</mat-label>
                      <input matInput [ngModel]="displayedEmail" (ngModelChange)="user.Email = $event" id="email" name="email">
                      <mat-error *ngIf="emailErrorMessage">{{ emailErrorMessage }}</mat-error>
                    </mat-form-field>
                  </div>
                  <div class="col-sm-6">
                    <mat-form-field appearance="fill" style="width: 100%" floatLabel="always">
                      <mat-label>Personnummer / samordningsnummer</mat-label>
                      <input [disabled]="user.CreatedFromSpar || !!user.EmploymentNumber" matInput required [ngModel]="user?.PersonalNumber" (ngModelChange)="onPersonalNumberChange($event)" ngModel pattern="[0-9]{12}" maxlength="12" id="PersonalNumber" name="PersonalNumber">
                      <mat-hint>12 siffror utan bindestreck</mat-hint>
                    </mat-form-field>
                  </div>
                  <div class="col-sm-6">
                    <mat-checkbox *ngIf="!user.CreatedFromSpar" matInput [ngModel]="user?.HasCoordinationNumber" ngModel (change)="changeCoordinationNumberValue($event)" id="hascono" name="hascono">Jag har enbart samordningsnummer,<br /> INGET svenskt personnummer</mat-checkbox>
                  </div>
                  <div *ngIf="!user.CreatedFromSpar && user.HasCoordinationNumber" class="col-sm-6">
                  </div>
                  <div *ngIf="!user.CreatedFromSpar && user.HasCoordinationNumber && coordinationNumberValid" class="col-sm-6">
                    <mat-form-field appearance="fill" style="width: 100%" floatLabel="always" ngModel>
                      <mat-label>ÅÅÅÅMMDD</mat-label>
                      <input matInput [ngModel]="user?.BirthYear" (ngModelChange)="user.BirthYear = $event" ngModel pattern="[0-9]{8}" maxlength="8" id="BirthYear" name="BirthYear">
                      <mat-hint>Ange födelsedatum (8 siffror)</mat-hint>
                    </mat-form-field>
                  </div>
                  <div *ngIf="!coordinationNumberValid" class="col-12">
                    <span style="text-align: right; font-size: 80%; color: red;">{{coordinationErrorMessage}}</span>
                  </div>
                </div>
              </mat-card>
              <mat-card class="card-margin input-card" *ngIf="appId == 1">
                <div class="row" style="margin-bottom: 15px;">
                  <!-- Adress -->
                  <div class="col-12">
                    <span class="settings-card-heading-icon" aria-hidden="true"><mat-icon>home</mat-icon></span>
                    <h4>Adress</h4>
                  </div>
                  <div class="col-sm-6">
                    <mat-form-field appearance="fill" style="width: 100%" floatLabel="always">
                      <mat-label>Folkbokföringsadress</mat-label>
                      <input [disabled]="user.CreatedFromSpar" matInput required [ngModel]="user?.Address" (ngModelChange)="user.Address = $event" id="address" name="address">
                    </mat-form-field>
                  </div>
                  <div class="col-sm-6">
                    <mat-form-field appearance="fill" style="width: 100%" floatLabel="always">
                      <mat-label>c/o</mat-label>
                      <input [disabled]="user.CreatedFromSpar" matInput [ngModel]="user?.Co" (ngModelChange)="user.Co = $event" id="coaddress" name="coaddress">
                    </mat-form-field>
                  </div>
                  <div class="col-sm-6">
                    <mat-form-field appearance="fill" style="width: 100%" floatLabel="always">
                      <mat-label>Postnummer</mat-label>
                      <input [disabled]="user.CreatedFromSpar" matInput required [ngModel]="user?.Zip" (ngModelChange)="user.Zip = $event" id="zip" name="zip">
                    </mat-form-field>
                  </div>
                  <div class="col-sm-6">
                    <mat-form-field appearance="fill" style="width: 100%" floatLabel="always">
                      <mat-label>Ort</mat-label>
                      <input [disabled]="user.CreatedFromSpar" matInput required [ngModel]="user?.City" (ngModelChange)="user.City = $event" id="city" name="city">
                    </mat-form-field>
                  </div>
                </div>
                <!-- Utdelningsadress -->

                <div class="row" style="margin-bottom: 15px;">
                  <div class="col-sm-6">
                    <mat-form-field appearance="fill" style="width: 100%" floatLabel="always">
                      <mat-label>Utdelningsadress (om annan än ovan)</mat-label>
                      <input matInput [ngModel]="user?.DeliveryAddress" (ngModelChange)="user.DeliveryAddress = $event" id="levaddress" name="levaddress">
                    </mat-form-field>
                  </div>
                  <div class="col-sm-6">
                    <mat-form-field appearance="fill" style="width: 100%" floatLabel="always">
                      <mat-label>c/o</mat-label>
                      <input matInput [ngModel]="user?.DeliveryCo" (ngModelChange)="user.DeliveryCo = $event" id="delcoaddress" name="delcoaddress">
                    </mat-form-field>
                  </div>
                  <div class="col-sm-6">
                    <mat-form-field appearance="fill" style="width: 100%" floatLabel="always">
                      <mat-label>Postnummer</mat-label>
                      <input matInput [ngModel]="user?.DeliveryZip" (ngModelChange)="user.DeliveryZip = $event" id="levzip" name="levzip">
                    </mat-form-field>
                  </div>
                  <div class="col-sm-6">
                    <mat-form-field appearance="fill" style="width: 100%" floatLabel="always">
                      <mat-label>Ort</mat-label>
                      <input matInput [ngModel]="user?.DeliveryCity" (ngModelChange)="user.DeliveryCity = $event" id="levcity" name="levcity" #levcity="ngModel">
                    </mat-form-field>
                  </div>
                  <div class="col-12 municipality-row">
                    <div class="municipality-value">
                      <span class="municipality-label">Kommun</span>
                      <span>{{ user.Municipality.Name }}</span>
                    </div>
                    <span class="municipality-tax">Skatt: {{user.Municipality.Tax * 100 | number:'1.2-2'}} %</span>
                  </div>
                  <div class="col-sm-6">
                    <mat-checkbox [checked]="registeredAbroad" (change)="onRegisteredAbroadChange($event.checked)" [disabled]="!countries.length">Jag är skriven utomlands</mat-checkbox>
                  </div>
                  <div class="col-sm-6" *ngIf="registeredAbroad">
                    <mat-form-field appearance="fill" style="width: 100%" floatLabel="always">
                      <mat-label>Land</mat-label>
                      <mat-select name="residenceCountry" [(ngModel)]="user.Country.Id" (ngModelChange)="onResidenceCountryChange($event)" required>
                        <mat-option *ngFor="let c of countries" [value]="c.Id">{{ c.Name }}</mat-option>
                      </mat-select>
                      <mat-error>Du måste ange ett land</mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </mat-card>

              <!-- BANK -->
              <mat-card *ngIf="appId == 1" class="card-margin input-card">

                <div class="row">
                  <div class="col-12">
                    <span class="settings-card-heading-icon" aria-hidden="true"><mat-icon>account_balance</mat-icon></span>
                    <h4>
                      Bankinformation
                    </h4>
                  </div>
                  <div class="col-sm-6">
                    <mat-form-field appearance="fill" floatLabel="always" style="width: 100%;">
                      <mat-label>Välj svensk/utländsk bank eller personkonto</mat-label>
                      <mat-select [ngModel]="bankEntryMode"
                                  name="bankEntryMode"
                                  (ngModelChange)="onBankEntryModeChange($event)">
                        <mat-option value="swedish">
                          Svensk bank
                        </mat-option>
                        <mat-option value="personkonto">
                          Nordea personkonto
                        </mat-option>
                        <mat-option value="international">
                          Utl&auml;ndsk bank
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>

                <div class="row" *ngIf="bankEntryMode !== 'international'" style="margin-bottom: 15px;">
                  <div class="col-12">
                    <div class="resolved-bank">
                      <span class="resolved-bank-label">Bank</span>
                      <strong class="resolved-bank-name">{{ user?.BankName || '-' }}</strong>
                    </div>
                  </div>
                </div>

                <div class="row" *ngIf="bankEntryMode === 'international'" style="margin-bottom: 15px;">
                  <div class="col-sm-6">
                    <mat-form-field appearance="fill" style="width: 100%" floatLabel="always">
                      <mat-label>BIC</mat-label>
                      <input matInput
                             required [ngModel]="user?.Bic"
                             (ngModelChange)="user.Bic = $event"
                            
                             id="bic"
                             pattern="^(?:[a-zA-Z0-9]{8}|[a-zA-Z0-9]{11})$"
                             name="bic">
                      <mat-error>Ange 8 eller 11 bokstäver och siffror</mat-error>
                      <mat-hint>Ange 8 eller 11 bokstäver och siffror</mat-hint>
                    </mat-form-field>
                  </div>

                  <div class="col-sm-6">
                    <mat-form-field appearance="fill" style="width: 100%" floatLabel="always">
                      <mat-label>IBAN</mat-label>
                      <input matInput
                             required [ngModel]="user?.Iban"
                             (ngModelChange)="user.Iban = $event"
                            
                             id="iban"
                             pattern="[a-zA-Z0-9]{0,34}"
                             name="iban">
                      <mat-error>Ange upp till 34 bokstäver och siffror</mat-error>
                      <mat-hint>Ange upp till 34 bokstäver och siffror</mat-hint>
                    </mat-form-field>
                  </div>

                </div>

                <div class="row" *ngIf="bankEntryMode !== 'international'" style="margin-bottom: 15px;">

                  <div class="col-sm-6" *ngIf="bankEntryMode === 'swedish'">
                    <mat-form-field appearance="fill" style="width: 100%" floatLabel="always">
                      <mat-label>Clearingnummer</mat-label>
                      <input matInput required [ngModel]="user.ClearingNumber"
                             (ngModelChange)="onClearingNumberChange($event)"
                             id="ClearingNumber"
                             name="ClearingNumber">
                      <mat-hint><span style="font-size: 80%;">{{ getClearingHint() }}</span></mat-hint>
                    </mat-form-field>
                  </div>

                  <div class="col-sm-6">
                    <mat-form-field appearance="fill" style="width: 100%" floatLabel="always">
                      <mat-label>Kontonummer</mat-label>
                      <input matInput required [ngModel]="user.AccountNumber"
                             (ngModelChange)="onAccountNumberChange($event)"
                             (focus)="onAccountNumberFocus()"
                             [readonly]="bankEntryMode === 'personkonto'"
                             id="AccountNumber"
                             name="AccountNumber">
                      <mat-hint *ngIf="getAccountHint()"><span style="font-size: 80%;">{{ getAccountHint() }}</span></mat-hint>
                    </mat-form-field>
                  </div>

                  <div class="col-12" *ngIf="bankValidationMessage">
                    <span style="font-size: 80%; color: red;">{{ bankValidationMessage }}</span>
                  </div>

                </div>
              </mat-card>
              <!-- /BANK -->

              <!-- SALARY PAYOUT -->
              <mat-card *ngIf="appId == 1" class="card-margin input-card">
                <div class="row" style="margin-bottom: 20px;">

                  <div class="col-12">
                    <span class="settings-card-heading-icon" aria-hidden="true"><mat-icon>payments</mat-icon></span>
                    <h4>Löneutbetalning</h4>
                  </div>

                  <div class="col-sm-12 col-md-3">
                    <mat-form-field appearance="fill" style="width: 100%" floatLabel="always">
                      <mat-label>Typ av utbetalning</mat-label>
                      <mat-select
                                  [ngModel]="user.PayoutType"
                                  (ngModelChange)="onPayoutTypeChange($event)"
                                  [ngModelOptions]="{standalone: true}">
                        <mat-option *ngFor="let s of payoutTypes" [value]="s.id">
                          {{ s.name }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>


                  <div class="col-sm-12 col-md-3">
                    <mat-form-field appearance="fill" style="width: 100%" floatLabel="always" *ngIf="user.PayoutType == 2">
                      <mat-label>Dag i månaden</mat-label>
                      <input matInput required [ngModel]="user.PayoutDay"
                             (ngModelChange)="onPayoutDayChange($event)"
                            
                             id="payoutday"
                             type="number"
                             min="1"
                             max="28"
                             name="payoutday">
                      <mat-error>
                        Ange en siffra mellan 1 och 28
                      </mat-error>
                      <mat-hint>
                        Ange en siffra mellan 1 och 28
                      </mat-hint>
                    </mat-form-field>
                  </div>

                  <div class="col-lg-6">
                    <span style="font-size: 80%">Välj om du vill ha lönen utbetald löpande när din kund betalar eller sammanställt en gång per månad.</span>
                  </div>
                </div>
              </mat-card>
              <!--/SALARY PAYOUT-->

              <mat-card *ngIf="appId == 1" class="card-margin input-card primary-employer-card">
                <div class="row" style="margin-bottom: 20px;">
                  <div class="col-12">
                    <span class="settings-card-heading-icon" aria-hidden="true"><mat-icon>business_center</mat-icon></span>
                    <h4>
                      Huvudsaklig arbetsgivare
                    </h4>
                  </div>
                  <div class="col-12">
                    <p style="margin-bottom: 0;"><b>Är lönen från SAMpoolen din huvudsakliga inkomst?</b></p>
                  </div>
                  <div class="col-lg-6">
                    <div class="primary-employer-choices" role="group" aria-label="Är SAMpoolen din huvudsakliga arbetsgivare?">
                      <mat-checkbox [checked]="user.SampoolenIsPrimaryEmployerAnswered && user.SampoolenIsPrimaryEmployer" (change)="changePrimaryEmployerValue(true, $event)" id="primaryemp-yes">Ja</mat-checkbox>
                      <mat-checkbox [checked]="user.SampoolenIsPrimaryEmployerAnswered && !user.SampoolenIsPrimaryEmployer" (change)="changePrimaryEmployerValue(false, $event)" id="primaryemp-no">Nej</mat-checkbox>
                    </div>
                    <p *ngIf="user.SampoolenIsPrimaryEmployerAnsweredDate" style="margin-top: 16px;">Du svarade {{ user.SampoolenIsPrimaryEmployerAnsweredDate | swedishDate : 'yyyy-MM-dd' }}</p>
                  </div>
                  <div class="col-lg-6 primary-employer-description">
                    <span>
                      <b>- Ja, detta kommer vara din största inkomst:</b> Välj Ja. Vi drar då skatt enligt din personliga skattetabell, för att undvika att du får restskatt. <br />
                      <b>- Nej, detta är en sidoinkomst:</b> Välj Nej. Vi drar då 30% i skatt, vilket oftast ger dig mer pengar i fickan vid varje utbetalning.
                    </span>
                    <p style="margin-top: 16px;">Om du ändrar ditt svar gäller förändringen direkt om du inte fått lön utbetald denna månad, och annars från och med nästa månad.</p>
                  </div>
                </div>
              </mat-card>

              <!--NOTIFICATIONS-->
              <mat-card *ngIf="appId == 1" class="card-margin input-card">
                <div class="row" style="margin-bottom: 20px;">
                  <div class="col-12">
                    <span class="settings-card-heading-icon" aria-hidden="true"><mat-icon>notifications_none</mat-icon></span>
                    <h4>Notifikationer</h4>
                  </div>
                  <div class="col-sm-12 col-md-6">
                    <mat-form-field appearance="fill" style="width: 100%" floatLabel="always">
                      <mat-label>Notifikationer</mat-label>
                      <mat-select [(ngModel)]="selectedNotificationTypes" (ngModelChange)="notificationSettingsChange($event)" [ngModelOptions]="{standalone: true}" multiple>
                        <mat-option *ngFor="let s of user.NotificationSettings" [value]="s.Type.Id">
                          {{ s.Type.Name }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="col-lg-6">
                    <span style="font-size: 80%">Här kan du bestämma vilka mail du vill få. Klicka ur de du inte vill ha.</span>
                  </div>
                </div>
              </mat-card>
              <!--/NOTIFICATIONS-->
              <!--VÄRVNINGSKOD-->
              <mat-card *ngIf="appId == 1" class="card-margin input-card">
                <div class="row" style="margin-bottom: 20px;">
                  <div class="col-12">
                    <span class="settings-card-heading-icon" aria-hidden="true"><mat-icon>group_add</mat-icon></span>
                    <h4>Personlig värvningskod</h4>
                  </div>
                  <div class="col-lg-6">
                    <mat-form-field appearance="fill" style="width: 100%;" floatLabel="always">
                      <mat-label>Värvningskod</mat-label>
                      <input [disabled]="true" matInput [ngModel]="user?.ReferralCode" id="referralCode" name="referralCode">
                      <button type="button" mat-icon-button matSuffix (click)="copyReferralCode(user?.ReferralCode)" title="Kopiera värvningskod" aria-label="Kopiera värvningskod">
                        <mat-icon [style.color]="copied ? 'green' : ''">content_copy</mat-icon>
                      </button>
                    </mat-form-field>
                  </div>
                  <div class="col-lg-6">
                    <!--<span style="font-size: 80%">Ge din värvningskod till en vän som ännu inte är medlem, så får ni båda 50 % rabatt på SAMpoolen-avgiften på er nästa faktura. <br /> Koden anges vid registrering av nytt medlemskonto, och du får rabatten när din vän fått betalt för sin första faktura.</span>-->
                  </div>
                  <div class="col-12 settings-table-heading">
                    <h4 class="mb-3">Mina värvningar</h4>

                    <div class="table-responsive">
                      <table class="table table-bordered table-striped col-12">
                        <thead class="table-light">
                          <tr class="text-muted small">
                            <th>Namn</th>
                            <th>Datum</th>
                            <!--<th>Faktura skickad</th>
                            <th>Rabattkod skapad</th>
                            <th>Rabattkod inlöst</th>-->
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let referral of referrals">
                            <td>{{ referral.ReferredUserFullName }}</td>
                            <td>{{ referral.ReferralDate | swedishDate: 'yyyy-MM-dd' }}</td>
                            <!--<td>{{ referral.HasSentInvoice ? '✔️' : '❌' }}</td>
                            <td>{{ referral.IsDiscountCodeIssued ? '✔️' : '❌' }}</td>
                            <td>{{ referral.IsDiscountCodeRedeemed ? '✔️' : '❌' }}</td>-->
                          </tr>
                        </tbody>
                      </table>
                    </div>

                  </div>
                </div>
              </mat-card>
              <!--/VÄRVNINGSKOD-->

              <mat-card *ngIf="appId == 1" class="card-margin input-card">
                <!--Tjänstepension-->
                <div class="row" style="margin-bottom: 20px;">
                  <div class="col-12">
                    <span class="settings-card-heading-icon" aria-hidden="true"><mat-icon>savings</mat-icon></span>
                    <h4>Avsättning till tjänstepension</h4>
                  </div>
                  <div class="col-lg-12" style="margin-bottom: 15px;">
                    <span style="font-size: 80%;">
                      Du kan göra avsättningar till din tjänstepension. Du kan i dina inställningar välja en generell avsättning, som du kan justera innan du skickar din faktura om så önskas.
                    </span>
                  </div>
                  <div class="col-lg-6">
                    <mat-form-field appearance="fill" style="width: 100%" floatLabel="always">
                      <mat-label>Procent av bruttolönen</mat-label>
                      <input matInput
                             [ngModel]="user?.PensionSavingsSettings?.Amount"
                             (ngModelChange)="user.PensionSavingsSettings.Amount = $event"
                             type="number"
                             min="0"
                             max="35"
                             step="0.1"
                             required
                             id="PensionAmount"
                             name="PensionAmount">
                      <span matSuffix>%</span>
                      <mat-hint>0–35 % av bruttolönen</mat-hint>
                      <mat-error>Ange en procentsats mellan 0 och 10</mat-error>
                    </mat-form-field>
                  </div>
                  <div class="col-lg-6">
                    <mat-form-field appearance="fill" style="width: 100%;" floatLabel="always">
                      <mat-label>Val av tjänstepensionsföretag</mat-label>
                      <select [ngModel]="user?.PensionSavingsSettings?.PensionSavingsCompany?.Id"
                              (ngModelChange)="pensionSavingsCompanyChanged($event)"
                              matNativeControl
                              [ngModelOptions]="{standalone: true}">
                        <option value="1">SPP</option>
                        <option value="2">Avanza</option>
                        <option value="3">Inget valt</option>
                      </select>
                    </mat-form-field>
                  </div>
                  <div class="col-lg-12">
                    <span style="font-size: 80%">
                      Löneväxling passar inte alla. Din allmänna pension minskar om din bruttolön per månad, efter löneväxling, blir lägre än 56 087 (2026). Om din lön blir mindre än så kan även din sjukpenning, föräldrapenning och andra socialförsäkringsförmåner påverkas.<br />Om du vill kan du välja var vi ska sätta in din tjänstepension. Om du inte gör ett aktivt val av tjänstepensionsföretag så sätter vi in pensionsavsättningen hos SPP.
                    </span>
                  </div>

                </div>
              </mat-card>

              <mat-card *ngIf="appId == 1" class="card-margin input-card">
                <!-- Skattejämkningar -->
                <div class="row">

                  <div class="col-12">
                    <span class="settings-card-heading-icon" aria-hidden="true"><mat-icon>receipt_long</mat-icon></span>
                    <h4>Skattejämkningar / frivillig ändring av skatt</h4>
                  </div>

                  <div class="col-12 d-flex justify-content-end">
                    <!--Knapp för skattejämkning-->
                    <button type="button" class="nomarginbutton tax-adjustment-add-button" mat-stroked-button (click)="addTaxAdjustment()">
                      <mat-icon aria-hidden="true">add</mat-icon>
                      Lägg till skattejämkning/ändra skatt
                    </button>
                  </div>

                  <!--Visar tabell för skattejämkningar-->
                  <div class="col-12" style="margin: 0 0 20px 0;" *ngIf="user.TaxAdjustments.length > 0">
                    <mat-table [dataSource]="dataSource">

                      <ng-container matColumnDef="type">
                        <mat-header-cell *matHeaderCellDef>Typ</mat-header-cell>
                        <mat-cell *matCellDef="let row">{{ row?.TaxAdjustmentType?.Name }}</mat-cell>
                      </ng-container>

                      <ng-container matColumnDef="startdate">
                        <mat-header-cell *matHeaderCellDef>Startdatum</mat-header-cell>
                        <mat-cell *matCellDef="let row">{{ row?.DateStart | swedishDate: 'yyyy-MM-dd' }}</mat-cell>
                      </ng-container>

                      <ng-container matColumnDef="enddate">
                        <mat-header-cell *matHeaderCellDef>Slutdatum</mat-header-cell>
                        <mat-cell *matCellDef="let row">{{ row?.DateEnd | swedishDate: 'yyyy-MM-dd' }}</mat-cell>
                      </ng-container>

                      <ng-container matColumnDef="maxamount">
                        <mat-header-cell *matHeaderCellDef>Maxsumma</mat-header-cell>
                        <mat-cell *matCellDef="let row">{{ row?.MaxAmount }}</mat-cell>
                      </ng-container>

                      <ng-container matColumnDef="temptax">
                        <mat-header-cell *matHeaderCellDef>Tillfällig skatt</mat-header-cell>
                        <mat-cell *matCellDef="let row">{{ row?.TemporaryTax *100 }} %</mat-cell>
                      </ng-container>

                      <ng-container matColumnDef="attachment">
                        <mat-header-cell *matHeaderCellDef>Uppladdad fil</mat-header-cell>
                        <mat-cell *matCellDef="let row">
                          <button type="button" *ngIf="row?.Attachment?.Id != null && row?.TaxAdjustmentType.Id != 3" mat-icon-button (click)="showFile(row.Attachment)" aria-label="Visa uppladdad fil" matTooltip="Visa uppladdad fil"><mat-icon aria-hidden="true">open_in_new</mat-icon></button>
                        </mat-cell>
                      </ng-container>

                      <ng-container matColumnDef="admin">
                        <mat-header-cell *matHeaderCellDef>Admin</mat-header-cell>
                        <mat-cell *matCellDef="let row">
                          <a mat-stroked-button mat-raised-button (click)="deleteTaxAdjustment(row)" style="margin-top: 8px;margin-right:20px;color:red;">radera</a>

                        </mat-cell>
                      </ng-container>

                      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                      <mat-row *matRowDef="let row; let i = index; columns: displayedColumns;" [class.older-tax-adjustment]="i > 0">
                      </mat-row>
                    </mat-table>
                    <!-- Slut tabell för skattejämkning-->
                  </div>

                </div>
              </mat-card>

              <div class="row">
                <div class="col-sm-6 offset-sm-6 save-button-container">
                  <button class="save-button"
                          color="accent"
                          mat-flat-button
                          [disabled]="isLoading || !f.valid || !saveValidates()">Spara</button>
                </div>
                <div class="col-sm-12" style="margin-bottom:15px;" *ngIf="!saveValidates()">
                  <div style="color:red;"><div>{{validationErrorMessage}}</div></div>
                </div>
              </div>

            </form>
          </div>
        </div>

        <!-- ********************* -->
        <!-- Company user settings -->
        <!-- ********************* -->

        <div class="settings-form-section" *ngIf="user && appId == 1 && user.IsCompany">
          <div class="settings-form-body backgroundcolor">
            <mat-card class="input-card">
              <form name="form" (ngSubmit)="onSubmit()" #f="ngForm" novalidate>
                <div class="row" style="margin-bottom: 15px;">
                  <div class="col-12 settings-card-heading">
                    <span class="settings-card-heading-icon" aria-hidden="true"><mat-icon>business</mat-icon></span>
                    <h4>Företagsuppgifter</h4>
                  </div>
                  <div class="col-lg-12">
                    <mat-form-field appearance="fill" style="width: 100%" floatLabel="always">
                      <mat-label>Företagets namn</mat-label>
                      <input required matInput [ngModel]="user.CompanyName" (ngModelChange)="user.CompanyName = $event" id="companyname" name="companyname" [disabled]="isChildAccount">
                    </mat-form-field>
                  </div>
                  <div class="col-lg-6">
                    <mat-form-field appearance="fill" style="width: 100%" floatLabel="always">
                      <mat-label>Telefon</mat-label>
                      <input matInput [ngModel]="user.Phone" (ngModelChange)="user.Phone = $event" id="telephone" name="telephone" [disabled]="isChildAccount">
                    </mat-form-field>
                  </div>
                  <div class="col-lg-6">
                    <mat-form-field appearance="fill" style="width: 100%" floatLabel="always">
                      <mat-label>E-post</mat-label>
                      <input matInput [ngModel]="displayedEmail" (ngModelChange)="user.Email = $event" id="email" name="email" [disabled]="isChildAccount">
                      <mat-error *ngIf="emailErrorMessage">{{ emailErrorMessage }}</mat-error>
                    </mat-form-field>
                  </div>
                  <div class="col-lg-6" *ngIf="user.Country.Id == null || user.Country.Name == 'Sverige'">
                    <mat-form-field appearance="fill" style="width: 100%" floatLabel="always">
                      <mat-label>Organisationsnr *</mat-label>
                      <input matInput [ngModel]="user.OrgNumber" (ngModelChange)="user.OrgNumber = $event" ngModel id="organisationsnr" name="Organisationsnr" [disabled]="isChildAccount">
                    </mat-form-field>
                  </div>
                  <div class="col-lg-6" *ngIf="user.Country.Id != null && user.Country.Name != 'Sverige'">
                    <mat-form-field appearance="fill" style="width: 100%" floatLabel="always">
                      <mat-label>VAT</mat-label>
                      <input matInput [ngModel]="user.Vat" (ngModelChange)="user.Vat = $event && user.OrgNumber = $event" ngModel id="VAT" name="VAT" [disabled]="isChildAccount">
                    </mat-form-field>
                  </div>
                  <div class="col-lg-6">
                    <mat-form-field appearance="fill" style="width: 100%" floatLabel="always">
                      <mat-label>Land</mat-label>
                      <mat-select name="country" id="country" [(ngModel)]="user.Country.Id" (ngModelChange)="user.Country.Id = $event; getCountryName(user.Country.Id);" [ngModelOptions]="{standalone: true}" required [disabled]="isChildAccount">
                        <mat-option *ngFor="let c of countries" [value]="c.Id">
                          {{ c.Name }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <!-- Kontaktperson -->
                  <div class="col-lg-12" style="margin: 20px 0">
                    <span class="settings-card-heading-icon" aria-hidden="true"><mat-icon>person_outline</mat-icon></span>
                    <h4>Kontaktperson</h4>
                  </div>
                  <div class="col-sm-6">
                    <mat-form-field appearance="fill" style="width: 100%" floatLabel="always">
                      <mat-label>Förnamn</mat-label>
                      <input matInput required [ngModel]="user.FirstName" (ngModelChange)="user.FirstName = $event" id="firstname" name="firstname" [disabled]="isChildAccount">
                    </mat-form-field>
                  </div>
                  <div class="col-sm-6">
                    <mat-form-field appearance="fill" style="width: 100%" floatLabel="always">
                      <mat-label>Efternamn</mat-label>
                      <input matInput required [ngModel]="user.LastName" (ngModelChange)="user.LastName = $event" id="lastname" name="lastname" [disabled]="isChildAccount">
                    </mat-form-field>
                  </div>
                  <div class="col-lg-6">
                    <mat-form-field appearance="fill" style="width: 100%" floatLabel="always">
                      <mat-label>Telefon till kontaktperson</mat-label>
                      <input matInput [ngModel]="user.ContactPhone" (ngModelChange)="user.ContactPhone = $event" id="telephoneftgcontact" name="telephonecontact" [disabled]="isChildAccount">
                    </mat-form-field>
                  </div>
                  <div class="col-lg-6">
                    <mat-form-field appearance="fill" style="width: 100%" floatLabel="always">
                      <mat-label>E-post till kontaktperson</mat-label>
                      <input matInput [ngModel]="user.ContactEmail" (ngModelChange)="user.ContactEmail = $event" id="emailftgcontact" name="emailcontact" [disabled]="isChildAccount">
                    </mat-form-field>
                  </div>
                  <!-- Fakturadress -->
                  <div class="col-lg-12" style="margin: 20px 0">
                    <span class="settings-card-heading-icon" aria-hidden="true"><mat-icon>home</mat-icon></span>
                    <h4>Företagsadress</h4>
                  </div>
                  <div class="col-lg-12">
                    <mat-form-field appearance="fill" style="width: 100%" floatLabel="always">
                      <mat-label>Företagsadress (gatuadress)</mat-label>
                      <input matInput [ngModel]="user.Address" (ngModelChange)="user.Address = $event" id="address" name="address" [disabled]="isChildAccount">
                    </mat-form-field>
                  </div>
                  <div class="col-lg-12">
                    <mat-form-field appearance="fill" style="width: 100%" floatLabel="always">
                      <mat-label>Företagsadress 2 (t ex c/o)</mat-label>
                      <input matInput [ngModel]="user.Co" (ngModelChange)="user.Co = $event" id="coaddress" name="coaddress" [disabled]="isChildAccount">
                    </mat-form-field>
                  </div>
                  <div class="col-lg-6">
                    <mat-form-field appearance="fill" style="width: 100%" floatLabel="always">
                      <mat-label>Postnummer</mat-label>
                      <input matInput [ngModel]="user.Zip" (ngModelChange)="user.Zip = $event" id="zip" name="zip" [disabled]="isChildAccount">
                    </mat-form-field>
                  </div>
                  <div class="col-lg-6">
                    <mat-form-field appearance="fill" style="width: 100%" floatLabel="always">
                      <mat-label>Ort</mat-label>
                      <input matInput [ngModel]="user.City" (ngModelChange)="user.City = $event" id="city" name="city" [disabled]="isChildAccount">
                    </mat-form-field>
                  </div>
                  <!-- Leveransadress -->
                  <div class="col-lg-12" style="margin: 20px 0">
                    <span class="settings-card-heading-icon" aria-hidden="true"><mat-icon>markunread_mailbox</mat-icon></span>
                    <h4>Särskild fakturaadress, om annan än ovan</h4>
                  </div>
                  <div class="col-lg-12">
                    <mat-form-field appearance="fill" style="width: 100%" floatLabel="always">
                      <mat-label>Fakturaadress 2 (t ex c/o)</mat-label>
                      <input matInput [ngModel]="user.DeliveryCo" (ngModelChange)="user.DeliveryCo = $event" id="levaddress" name="levaddress2" [disabled]="isChildAccount">
                    </mat-form-field>
                  </div>
                  <div class="col-lg-12">
                    <mat-form-field appearance="fill" style="width: 100%" floatLabel="always">
                      <mat-label>Fakturaadress (gatuadress)</mat-label>
                      <input matInput [ngModel]="user.DeliveryAddress" (ngModelChange)="user.DeliveryAddress = $event" id="levaddress" name="levaddress" [disabled]="isChildAccount">
                    </mat-form-field>
                  </div>
                  <div class="col-lg-6">
                    <mat-form-field appearance="fill" style="width: 100%" floatLabel="always">
                      <mat-label>Postnummer</mat-label>
                      <input matInput [ngModel]="user.DeliveryZip" (ngModelChange)="user.DeliveryZip = $event" id="levzip" name="levzip" [disabled]="isChildAccount">
                    </mat-form-field>
                  </div>
                  <div class="col-lg-6">
                    <mat-form-field appearance="fill" style="width: 100%" floatLabel="always">
                      <mat-label>Ort</mat-label>
                      <input matInput [ngModel]="user.DeliveryCity" (ngModelChange)="user.DeliveryCity = $event" id="levcity" name="levcity" #levcity="ngModel" [disabled]="isChildAccount">
                    </mat-form-field>
                  </div>
                  <!-- Bankuppgifter -->
                  <div class="col-lg-12" style="margin: 20px 0">
                    <span class="settings-card-heading-icon" aria-hidden="true"><mat-icon>account_balance</mat-icon></span>
                    <h4>Bankuppgifter</h4>
                  </div>
                  <div class="row col-lg-12" *ngIf="user.Country.Id == null || user.Country.Name == 'Sverige'">
                    <div class="col-lg-6">
                      <mat-form-field appearance="fill" style="width: 100%" floatLabel="always">
                        <mat-label>Banknamn</mat-label>
                        <input matInput [ngModel]="user.BankName" id="BankName" name="BankName" [disabled]="isChildAccount" readonly>
                      </mat-form-field>
                    </div>
                    <div class="col-lg-3">
                      <mat-form-field appearance="fill" style="width: 100%" floatLabel="always">
                        <mat-label>Clearingnummer</mat-label>
                        <input matInput [ngModel]="user.ClearingNumber" (ngModelChange)="onClearingNumberChange($event)" id="ClearingNumber" name="ClearingNumber" [disabled]="isChildAccount">
                      </mat-form-field>
                    </div>
                    <div class="col-lg-3">
                      <mat-form-field appearance="fill" style="width: 100%" floatLabel="always">
                        <mat-label>Kontonummer</mat-label>
                        <input matInput [ngModel]="user.AccountNumber" (ngModelChange)="onAccountNumberChange($event)" id="AccountNumber" name="AccountNumber" [disabled]="isChildAccount">
                      </mat-form-field>
                    </div>
                    <div class="col-lg-6">
                      <mat-form-field appearance="fill" style="width: 100%" floatLabel="always">
                        <mat-label>Bankgiro</mat-label>
                        <input matInput [ngModel]="user.Bankgiro" (ngModelChange)="user.Bankgiro = $event" id="AccountNumber" name="Bankgiro" [disabled]="isChildAccount">
                      </mat-form-field>
                    </div>
                    <div class="col-lg-6">
                      <mat-form-field appearance="fill" style="width: 100%" floatLabel="always">
                        <mat-label>Plusgiro</mat-label>
                        <input matInput [ngModel]="user.Plusgiro" (ngModelChange)="user.Plusgiro = $event" id="AccountNumber" name="Plusgiro" [disabled]="isChildAccount">
                      </mat-form-field>
                    </div>
                  </div>
                  <!-- Övrigt -->
                  <div class="col-lg-12" style="margin: 20px 0">
                    <span class="settings-card-heading-icon" aria-hidden="true"><mat-icon>tune</mat-icon></span>
                    <h4>Övrigt</h4>
                  </div>
                  <div class="row col-12" style="height: 67px;">
                    <div class="col-lg-6" *ngIf="user.HasCustomServiceFee">
                      <mat-form-field appearance="fill" style="width: 100%" floatLabel="always">
                        <mat-label>Avtalad serviceavgift, procent</mat-label>
                        <input disabled type="number" matInput [ngModel]="CustomServiceFee" id="servicefee" name="servicefee" #servicefee="ngModel" [disabled]="isChildAccount">
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="row col-12">
                    <div class="col-lg-6">
                      <mat-form-field appearance="fill" style="width: 100%" floatLabel="always">
                        <mat-label>Provision, procent</mat-label>
                        <input type="number" matInput [ngModel]="Commission" (ngModelChange)="Commission = $event" id="commission" name="commission" #commission="ngModel" [disabled]="isChildAccount">
                      </mat-form-field>
                    </div>
                    <div class="col-lg-6">
                      <span style="font-size: 80%;">Om du tar provision/förmedlingsavgift för uppdrag du fakturerar en annan slutkund för anger du din procentsats här (den går även att ändra per faktura)</span>
                    </div>
                  </div>
                  <div class="row col-12">
                    <div class="col-lg-6">
                      <span *ngIf="user.FTax">Är registrerad för F-skatt</span>
                      <span *ngIf="!user.FTax">Är ej registrerad för F-skatt</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-6 offset-sm-6 save-button-container">
                      <button class="save-button"
                              color="accent"
                              *ngIf="!isChildAccount"
                              [disabled]="isLoading || !f.valid || !saveValidates()"
                              mat-flat-button
                              style="margin-top: 20px;">Spara</button>
                    </div>
                  </div>
                  <div class="col-12" *ngIf="!saveValidates()" style="text-align: right; font-size: 80%;">{{validationErrorMessage}}</div>
                </div>
              </form>
            </mat-card>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
